var map = {
	"./photo-1-1.webp": "aa26",
	"./photo-2-1.webp": "cd65",
	"./photo-3-1.webp": "979c",
	"./photo-4-1.webp": "aa83",
	"./photo-5-1.webp": "cf5b",
	"./photo-6-1.webp": "750c",
	"./photo-7-1.webp": "be93",
	"./photo-8-1.webp": "c310",
	"./photo-9-1.webp": "91d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "efa2";